import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param tenantId
 * @param payload
 * @param poId
 */
class RfqServices {
/**
 * @return {Promise<*>}
 */
getRfq = async (orgId, tenantId, page, limit, status, onDate, fromDate, toDate, searchKeyword, is_list) => {
  let url = `${Constants.RFQ}?`;
  if (orgId) url += `org_id=${orgId}&`;
  if (tenantId) url += `tenant_id=${tenantId}&`;
  if (status) url += `status=${status}&`;
  if (onDate) url += `on_date=${onDate}&`;
  if (fromDate) url += `from_date=${fromDate}&`;
  if (toDate) url += `to_date=${toDate}&`;
  if (page) url += `page=${page}&`;
  if (limit) url += `limit=${limit}&`;
  if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
  if (is_list) url += `is_list=true&`;

  const orgRfq = await Helpers.get({ url });
  return orgRfq;
}

/**
*
* @param payload
* @return {Promise<*>}
*/
createRfq = async (payload) => {
  const addedProduct = await Helpers.post({
    url: Constants.RFQ,
    data: payload,
  });
  return addedProduct;
}

/**
*
* @param payload
* @return {Promise<*>}
*/
updateRfq = async (payload) => {
  const addedProduct = await Helpers.put({
    url: Constants.RFQ,
    data: payload,
  });
  return addedProduct;
}

/**
*
* @param payload
* @return {Promise<*>}
*/
updateRfqParticipant = async (payload) => {
  const addedProduct = await Helpers.put({
    url: `${Constants.RFQ}/participant`,
    data: payload,
  });
  return addedProduct;
}

/**
*
* @param payload
* @return {Promise<*>}
*/
updateRfqConfig = async (payload) => {
  const addedProduct = await Helpers.put({
    url: `${Constants.RFQ}/configuration`,
    data: payload,
  });
  return addedProduct;
}

  /**
  * @param orgId
  * @param tenantId
  * @param rfqId
  * @return {Promise<*>}
  */
  getRfqById = async (orgId, tenantId, rfqId) => {
    let url = `${Constants.RFQ}?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (rfqId) url += `rfq_id=${rfqId}&`;

    const selectedRfq = await Helpers.get({ url });
    return selectedRfq;
  }

/**
*
* @param payload
* @return {Promise<*>}
*/
sendRfqNotification = async (payload) => {
  const addedProduct = await Helpers.post({
    url: `${Constants.RFQ}/notification`,
    data: payload,
  });
  return addedProduct;
}

  /**
 *
 * @param payload
 * @return {Promise<*>}
 */
  deleteRfq = async (payload) => {
    const deleteRfq = await Helpers.delete({
      url: Constants.RFQ,
      data: payload,
    });
    return deleteRfq;
  }

  /**
   *
   * @param payload
   * @return
   */
     updateRfqStatus = async (payload) => {
       const rfq = await Helpers.put({
         url: `${Constants.RFQ}/status`,
         data: payload,
       });
       return rfq;
     }

  /**
   *
   * @param accessToken
   * @returns {Promise<*>}
   */
  getPublicRfq = async (accessToken) => {
    const url = `${Constants.RFQ}/public?public_token=${accessToken}`;
    const rfq = await Helpers.get({
      url,
    });
    return rfq;
  }

  /**
   *
   * @param actionType
   * @param payload
   * @returns {Promise<*>}
   */
  negotiationAction = async (actionType, payload) => {
    let apiType = '';
    if (actionType === 'addNegotiation') apiType = '/negotiation'; // public
    if (actionType === 'addCounterNegotiation') apiType = '/counter_negotiation';
    if (actionType === 'revokeCounter') apiType = '/revoke_counter';
    if (actionType === 'acceptCounter') apiType = '/accept_counter'; // public
    if (actionType === 'acceptRfq') apiType = '/accept';
    const url = `${Constants.RFQ}${apiType}`;
    const rfq = await Helpers.post({
      url,
      data: payload,
    });
    return rfq;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  getAcceptedOffers = async (payload) => {
    const url = `${Constants.RFQ}/accepted_offers?rfq_id=${payload?.rfq_id}`;
    const rfq = await Helpers.get({
      url,
    });
    return rfq;
  }

  /**
 * @return {Promise<*>}
 */
   getRfqParticipantNegotiations = async (rfqParticipantId) => {
     let url = `${Constants.RFQ}/participant/negotiations?`;
     if (rfqParticipantId) url += `rfq_participant_id=${rfqParticipantId}&`;

     const orgRfq = await Helpers.get({ url });
     return orgRfq;
   }
}
export default new RfqServices();
